import { DateTime, Settings } from "luxon";
import type { DateTimeFormatOptions } from "luxon";

export const formatDateAsLocaleString = (
  dateTime: DateTime,
  useLocalTime: boolean = false,
  formatOpts: DateTimeFormatOptions = DateTime.DATETIME_SHORT_WITH_SECONDS
): string | undefined => {
  if (useLocalTime) {
    const localTime = dateTime.toLocal();
    return `${localTime.toLocaleString(formatOpts)} (${localTime.zoneName})`;
  }
  return `${dateTime.toLocaleString(formatOpts)} (${dateTime.zoneName})`;
};

export const formatDateAsLocaleDateString = (
  dateTime: DateTime,
  useLocalTime: boolean = false,
  includeZoneName: boolean = true
): string => {
  const zonedTime = useLocalTime ? dateTime.toLocal() : dateTime;
  const date = zonedTime.toLocaleString(DateTime.DATE_SHORT);
  return includeZoneName ? `${date} (${zonedTime.zoneName})` : date;
};

export const formatDateOnly = (dateTime: DateTime): string => formatDateAsLocaleDateString(dateTime, false, false);

/**
 * A compact date with no locale variation, e.g. "14 Sep 26".
 * @param dateTime
 */
export const formatDateShort = (dateTime: DateTime): string => dateTime.toFormat("d MMM yy");

export const formatDateAsTimeString = (dateTime: DateTime, timeZone: string, useLocalTime?: boolean): string => {
  const labelFormat = "h:mm a";
  const localeOptions = {
    locale: Settings.defaultLocale,
    outputCalendar: Settings.defaultOutputCalendar,
    numberingSystem: Settings.defaultNumberingSystem,
  };

  if (useLocalTime) {
    const zonedTime = dateTime.setZone(timeZone, { keepLocalTime: true });
    const localTime = zonedTime.toLocal();

    return `${localTime.toLocaleString(DateTime.TIME_SIMPLE)} (${localTime.zoneName})`;
  }

  return dateTime.toFormat(labelFormat, localeOptions);
};
